import * as React from 'react';
import SvgIcon from '@mui/joy/SvgIcon';

export default function DiscordIcon() {
    return (
        <SvgIcon fontSize="xl" viewBox="0 0 24 24">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 48 48">
                <radialGradient id="Fr~bqA9iZI6v1mPZVXxEWa_LOWwEDik1xs8_gr1" cx="24" cy="560.111" r="32.253"
                                gradientTransform="matrix(1 0 0 -1 0 570.11)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#8c9eff"></stop>
                    <stop offset=".368" stop-color="#889af8"></stop>
                    <stop offset=".889" stop-color="#7e8fe6"></stop>
                    <stop offset="1" stop-color="#7b8ce1"></stop>
                </radialGradient>
                <path fill="url(#Fr~bqA9iZI6v1mPZVXxEWa_LOWwEDik1xs8_gr1)"
                      d="M40.107,12.15c-0.065-0.102-0.139-0.182-0.236-0.255c-0.355-0.267-5.744-3.889-9.865-3.889	c-0.258,0-0.825,1.1-1.016,1.987c-1.994,0.002-7.996-0.003-9.993,0.006c-0.236-0.838-0.844-1.99-1.008-1.99	c-4.122,0-9.487,3.606-9.861,3.887c-0.097,0.073-0.17,0.153-0.236,0.255c-0.708,1.107-5.049,8.388-5.892,21.632	c-0.009,0.142,0.04,0.289,0.135,0.395C6.728,39.321,13.318,39.929,14.724,40c0.167,0.008,0.335-0.059,0.427-0.199l1.099-1.665	l-3.246-1.54v-1.609c6.329,2.817,15.356,3.104,21.993,0.017l0.027,1.588l-3.205,1.65l1.028,1.559c0.092,0.14,0.26,0.208,0.427,0.199	c1.407-0.072,7.996-0.679,12.588-5.823c0.095-0.106,0.144-0.253,0.135-0.395C45.156,20.538,40.815,13.257,40.107,12.15z"></path>
                <ellipse cx="30.5" cy="26" opacity=".05" rx="4.5" ry="5"></ellipse>
                <ellipse cx="30.5" cy="26" opacity=".05" rx="4" ry="4.5"></ellipse>
                <ellipse cx="30.5" cy="26" fill="#fff" rx="3.5" ry="4"></ellipse>
                <ellipse cx="17.5" cy="26" opacity=".05" rx="4.5" ry="5"></ellipse>
                <ellipse cx="17.5" cy="26" opacity=".05" rx="4" ry="4.5"></ellipse>
                <ellipse cx="17.5" cy="26" fill="#fff" rx="3.5" ry="4"></ellipse>
            </svg>
        </SvgIcon>
    );
}
